
import CinemaMap from './Components/Maps/CinemaMap.js';
import useFilters from './Components/Hooks/useFilters.js';
import FilterPanel from './Components/SearchPanel/FilterPanel.js';
import { useEffect,useState } from 'react';

function App() {

  const [schedules, setSchedules] = useState([]);

  const {       
    movieOptions,
    selectedMovies,
    addMovie,
    removeMovie,
    dimensions,
    selectedDimensions,
    addDimension,
    removeDimension
  } = useFilters();

  useEffect(() => {
    const searchParams = new URLSearchParams();
    selectedMovies.forEach(id => {
      searchParams.append("movieId", id);
    });
    selectedDimensions.forEach(dim => {
      searchParams.append("dimension", dim);
    });
    console.log(searchParams.toString());
    console.log(selectedMovies);
    console.log(selectedDimensions);
    if(searchParams.toString()){
      console.log("Searching for schedules");
      fetch(`/api/schedules?${searchParams.toString()}`)
    .then(r => r.json())
    .then(data => setSchedules(data));
    }
      
  }, [selectedMovies, selectedDimensions])


  useEffect(() => {

    console.log(schedules);
    
  },[schedules])

  return (
    <div className="App">
      <FilterPanel
        dimensionsOptions={dimensions}
        selectedDimensions={selectedDimensions}
        addDimension={addDimension}
        removeDimension={removeDimension}
        movieOptions={movieOptions}
        selectedMovies={selectedMovies}
        addMovie={addMovie}
        removeMovie={removeMovie}
      />
      <CinemaMap
        schedules={schedules}
        selectedMovies={selectedMovies}
        selectedDimensions={selectedDimensions}
      />
    </div>
  );
}

export default App;
